import { SearchConfig } from "./api.model"
import { FieldOption } from "./form.model"

export type cardConfig = {
    id: string,
    class: string
    link?: string
    icon?: string
    label: string | number,
    value?: string,
    isLoading?: boolean,
    cardStyle: "iconWithLabel" | "labelWithValue"
}

export const SPINNER_AREA = {
    FullScreen: 'fullscreen',
    Chart: 'chart',
    Popup: 'popup'
}

export const ListActions = {
    edit: 'Edit',
    view: 'View',
    delete: 'Delete'
}

export const BUTTON_NAMES = {
    default: "Button 1",
    Search: "Search",
    Reset: "Reset",
    Login: "Login",
    BackToDashboard: "Back To Dashboard",
    Yes: "Yes",
    No: "No",
    Create: "Create",
    Cancel: "Cancel",
    Modify: "Modify",
    Update: "Update",
    TenureAdjustment: 'Tenure Adjustment',
    Adjust: 'Adjust'
} as const

export const LAYOUT_TYPE = {
    List: 'list',
    Tab: 'tab',
    FilterTab: 'filterTab',
    IntegratedTab: 'integratedTab',
    Dashboard: 'dashboard'
}

export const DYNAMIC_IDENTIFIER = {
    startKey: '$|-',
    endkey: '-|$',
    lastYear: '$|-lastYear-|$',
    selectedField: '$|-selectedField-|$',
    period: '$|-period-|$',
    globalyear: '$|-globalYear-|$',
    drilldownField: '$|-drilldown-|$'
} as const;

export const INPUT_MODE = {
    View: 'view',
    Edit: 'edit'
} as const

export const FETCH_METHODS = {
    Post: 'POST',
    Get: 'Get'
} as const

export type FetchMethod = typeof FETCH_METHODS[keyof typeof FETCH_METHODS];

export type ListActions = typeof ListActions[keyof typeof ListActions];

export type InputMode = typeof INPUT_MODE[keyof typeof INPUT_MODE];

export type LayoutType = typeof LAYOUT_TYPE[keyof typeof LAYOUT_TYPE];

export type ButtonNames = typeof BUTTON_NAMES[keyof typeof BUTTON_NAMES];

export type SpinnerArea = typeof SPINNER_AREA[keyof typeof SPINNER_AREA];

export const defaultNumberOfColumns = 3;

export interface UserInfo {
    userName: string;
    workdayId: string;
}
export type OptionFields = {
    name: string,
    keyValuePair: FieldOption
}

export interface ErrorMsgInfo {
    status: string | number,
    title: string,
    description?: string,
    actions?: Array<CallbackAction>
}
interface CallbackAction {
    callback: any,
    label: string,
    icon?: string
}

export type OptionsFetchConfig = { fields: Array<OptionFields>, searchConfig: SearchConfig }

export const User_Roles = {  
    Super_Admin: 'S',
    Admin: 'A',
    User: 'U'
} as const

export const ScreenNames = {
    staffMaster: 'staffMaster',
    jobRoleSummary: 'jobRoleSummary',
    dealerTrainingBilling: 'dealerTrainingBilling',
    elevateBilling: 'elevateBilling',
    eventBilling: 'eventBilling',
    aseLexus: 'ase-Lexus',
    pcSupport: 'pcSupport',
    lexusTurnoverReport: 'lexusTurnoverReport',
    distributionList: 'distributionList',
    tenure: 'tenure',
    tenureAdmin: 'tenureAdmin',
    information: 'information',
    eliteCertificationReport: 'elite',
    eventDashboard: 'eventDashboard',
    eventAdmin: 'eventAdmin',
    impactAnalysis: 'impact-analysis',
    dealerScorecard: 'dealerScorecard',
    dealerScorecardDashboard: 'dealerScorecardDashboard',
    survey: 'survey',
    googleAnalytics: 'googleAnalytics',
    pasDashboard: 'pasDashboard',
}
export const AseScreens = {
    aseLexusDetail: 'aseLexusDetail',
    rejectionReport: 'rejectionReport',
    collisionRejectionReport: 'collisionRejectionReport'
}

export const FileDownloadSearchConfig: SearchConfig = {
    method: FETCH_METHODS['Post'],
    path: 'getSignedUrl',
    body: {
        bucketName: '',
        key: '',
        type: 'Download'
    }
}